import { Content } from "@/ui";
import { getRoute } from "@/getters/getRoute";
import { simple_pages_helper } from "@/helpers/simple_pages_helper";
import { createTitle } from "@/functions/createTitle";
import { getNestedRoutes } from "@/functions/getNestedRoutes";
import sn from "@/snippets";

export default function Page({ content }) {
  return (
    <>
      <Content items={content} logoCarousel={false} />
    </>
  );
}

export async function getStaticProps() {
  const page = simple_pages_helper.find("our-social-impact", "url_slug", "933d52cb-bbc5-44e3-830f-1a1df3ff25bb");
  const pages = getNestedRoutes({ url_slugs: ["about-us", "our-social-impact"] });
  const [_page, prevPage] = [...pages].reverse();
  const logoItems = page && page["logo_carousel_items"]?.length > 0 ? page["logo_carousel_items"] : logo_carousel_helper.fetch({
    filter: (i) => i.tags.toLowerCase().includes(_page.url_slug ?? "home") || i.tags.includes("*"),
  });

  return {
    props: {
      meta: {
        title: createTitle(page.title),
        canonical: "https://www.bluearrow.co.uk/about-us/our-social-impact/"
      },
      content: [
        { component: "BreadcrumbNavigation", props: { items: pages } },
        sn.header({ page, prevPage }),
        sn.statCounterWidget({ page }),
        sn.richText({
          page,
          config: { bodyKey: "intro" },
          className: "py-4 py-md-5",
        }),
        sn.promotionalCarousel({ page }),
        ...sn.narrativePanels({
          items: page.narrative_panels
        }),
        ...sn.logoCarousel({ page, after: { component: "Divider" } }),
        ...sn.logoCarousel({
          page,
          config: {
            itemsKey: "logo_carousel_2_items",
            titleKey: "logo_carousel_2_title",
          },
        }),
      ],
    },
  };
}